<template>
  <div>
    <header id="masthead" class="registration">
      <div class="wp1200">
       <router-link class="logo" :to="{ name: 'dashboard' }"></router-link>
        <div v-if="showToastError">
          <div
            style="
              margin-bottom: 25px;
              padding: 20px;
              background-color: #ef5451;
              border-radius: 20px;
              color: white;
              display: -webkit-flex;
              display: flex;
              align-items: center;
            "
          >
            <span class="warpit_icon_alert" style="font-size: 32px; margin-right: 15px"></span>
            {{ showToastMessage }}
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration passReset">
          <hr class="blue" />
          <h4>{{ $t("profile.change_password") }}</h4>
          <form action="#" class="custom-form"
            v-on:submit.prevent="onSubmit()"
            >
            <div class="form-group" v-bind:class="{ 'not-empty': !isOldPasswordEmpty }">
              <input
                v-bind:type="oldPasswordType"
                class="form-control"
                name="pass"
                id="pass"
                v-model="form.oldPassword"
                required
                @blur="formUtilsCheckOldPassword()"
              />
              <label for="pass" class="animated-label">{{ $t("profile.change_password_old") }}</label>
              <span
                class="icon passVisible"
                v-bind:class="{
                  warpit_icon_eye: isOldPasswordEyeSlashClass,
                  'warpit_icon_eye-slash': !isOldPasswordEyeSlashClass,
                }"
                v-on:click.prevent="formUtilsShowOldPassword()"
              ></span>
              <span class="line"></span>
            </div>
            <div class="form-group" v-bind:class="{ 'not-empty': !isPasswordEmpty }">
              <input
                v-bind:type="passwordType"
                class="form-control"
                name="pass"
                id="pass"
                v-model="form.password"
                required
                @blur="formUtilsCheckPasswordSave()"
              />
              <label for="pass" class="animated-label">{{ $t("profile.change_password_new") }}</label>
              <span
                class="icon passVisible"
                v-bind:class="{
                  warpit_icon_eye: isPasswordEyeSlashClass,
                  'warpit_icon_eye-slash': !isPasswordEyeSlashClass,
                }"
                v-on:click.prevent="formUtilsShowPassword()"
              ></span>
              <span class="line"></span>
            </div>
            <span class="errorSexTxt" v-if="errors.password" for="password">
              {{ $t("profile.change_password_error") }}
            </span>
            <div class="form-group" v-bind:class="{ 'not-empty': !isConfirmPasswordEmpty }">
              <input
                v-bind:type="passwordConfirmationType"
                class="form-control"
                name="pass"
                id="pass2"
                v-model="form.passwordConfirmation"
                required
                @blur="formUtilsCheckPasswordConfirmation()"
              />
              <label for="pass2" class="animated-label">{{ $t("profile.change_password_new_confirm") }}</label>
              <span
                class="icon passVisible"
                v-bind:class="{
                  warpit_icon_eye: isConfirmationPasswordEyeSlashClass,
                  'warpit_icon_eye-slash': !isConfirmationPasswordEyeSlashClass,
                }"
                v-on:click.prevent="formUtilsShowConfirmationPassword()"
              ></span>
              <span class="line"></span>
            </div>
            <span
              class="errorSexTxt"
              v-if="errors.confirmPassword"
              for="password"
            >{{ $t("profile.change_password_no_match") }}</span>
            <div class="next flex">
              <a class="txt" href v-on:click.prevent="formUtilsCancel()">{{ $t("profile.change_password_cancel") }}</a>
              <a
                class="join smallFont smallWidth hoverEffect"
                ref="joinButton1"
                v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:click.prevent="onSubmit()"
                href="javascript:void(0);"
              >
                <label>{{ $t("profile.change_password_confirm") }}</label>
                <span
                  class="effect"
                  ref="effectButton1"
                  v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
                ></span>
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { 
  formUtilsShowOldPassword, 
  formUtilsCheckPasswordSave, 
  formUtilsCheckOldPassword, 
  formUtilsMouseHoverEffect, 
  formUtilsShowPassword,
  formUtilsShowConfirmationPassword, 
  formUtilsCheckPasswordConfirmation,
  formUtilsCancel
} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      showToastError: false,
      showToastMessage: "",

      isOldPasswordEyeSlashClass: true,
      isOldPasswordEmpty: true,
      oldPasswordType: "password",

      isPasswordEyeSlashClass: true,
      isPasswordEmpty: true,
      passwordType: "password",

      isConfirmationPasswordEyeSlashClass: true,
      isConfirmPasswordEmpty: true,
      passwordConfirmationType: "password",

      topX: 1,
      leftX: 1,
      form: {
        oldPassword: "",
        password: "",
        passwordConfirmation: "",
      },
      errors: {
        oldPassword: false,
        password: false,
        confirmPassword: false,
      },
      recaptchaToken: "",
      recaptchaSiteKey: window.VUE_APP_RECAPTCHA_KEY,
    };
  },
  components: {
  },
  setup() {},
  methods: {
    formUtilsShowPassword,
    formUtilsMouseHoverEffect,
    formUtilsCheckOldPassword,
    formUtilsCheckPasswordSave,
    formUtilsShowOldPassword,
    formUtilsShowConfirmationPassword,
    formUtilsCheckPasswordConfirmation,
    formUtilsCancel,


    async onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      this.formUtilsCheckPasswordSave();
      if (this.errors.password === true) {
        return;
      }

      this.formUtilsCheckPasswordConfirmation();
      if (this.errors.confirmPassword === true) {
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    sendForm(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      if(this.form.oldPassword === this.form.password){
        this.showToastMessage = this.$t('profile.same_password');
        this.showToastError = true;
        return false;
      }

      this.$http
        .put("api/v1/userPassword", this.form)
        .then(() => {
          this.$emit("hide");
        })
        .then(() => {
          this.$router.replace({ name: "change-password-success" });
        })
        .catch((e) => {
          this.showToastMessage = this.$t('error.error_old_match');
          this.showToastError = true;
        });
    },

    logout() {
      this.$store.dispatch("user/logout");
      this.$router.replace({ name: "home" });
    }

  },
};
</script>

<style >
</style>